import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _HiringModalityStage } from '../../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idHiringModality: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectHiringModalityStage = ({ idHiringModality, idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_HiringModalityStage);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idHiringModality) {
            getLista();
        }
    }, [idHiringModality]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDHiringModalityStage === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDHiringModalityStage,
                    label: found.DataBeanProperties.Name,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getHiringModalityStageCatalog(idHiringModality, null, null).then(
            (resp: any) => {
                // if (resp) setLista(resp);
                setLista(resp.List)
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDHiringModalityStage,
        label: item.DataBeanProperties.Name,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Etapas de Modalidad"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Etapa de Modalidad..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
